'use client'

import { useEffect } from 'react'
import { ToastContainer } from 'react-toastify'

import { getTranslate } from '@/legacy-src/utilities/i18n'
import Toaster from '@/legacy-src/utilities/toaster'

const ToastProvider = () => {
  useEffect(() => {
    const { t } = getTranslate()
    Toaster.setTranslator(t)
  }, [])

  return <ToastContainer autoClose={5000} theme="colored" />
}

export default ToastProvider
